export default ".capitalize {\n  text-transform: capitalize;\n}";